import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { Camera } from '@ionic-native/camera';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the ServisDuzenlePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-servis-duzenle',
  templateUrl: 'servis-duzenle.html',
})
export class ServisDuzenlePage {
  gununtarihi;
  tarihformati;
  isler: any = { ID: -1, DurumID: 1 };
  gidenaksesuar = [];
  tarih: any;
  MarkaListesi = [];
  aranan = "";
  skip: number = 0;
  take: number = 50;
  DurumListesi = [];
  vWKayit: any = {};
  islemyapan = this.ortak.aktifKullaniciAdi;
  base64Image: string;
  resimgoster: string;
  kayitliresim = "assets/imgs/logo.png"
  resimklasor = [];
  AciklamaListesi = [];
  personelListesi=[];

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public viewCtrl:ViewController,
    public camera:Camera,
    public modalCtrl:ModalController,
    public toast:ToastController,
   
     public navParams: NavParams)
     {
      if (navParams.get("vWKayit") != null) {
    this.vWKayit = navParams.get("vWKayit");
    var data = new FormData();

    data.append("Servis_id", this.vWKayit.ID);
    this.bllOrtak.islem(data, "ServisGetirByID", "", false).then(a => {
      var Sonuc = <any>a;
      this.isler = Sonuc.SonucObject;
      if (this.isler.ResimYolu != null) {
        this.kayitliresim = this.ortak.storageSunucuAdresiGetir + this.isler.ResimYolu;
      }
      else
        this.kayitliresim = "assets/imgs/logo.png";
    }
    )

  }
 
}
ionViewDidLoad() {
  this.MarkalariGetir();
  this.DurumGetir();
  this.AciklamaGetir();
  this.servisaksesuargetir();
  this.PersonelleriGetir();
}
servisaksesuargetir() {
  var formData = new FormData();
  formData.append("servisaksesuar", JSON.stringify(this.vWKayit));

  this.bllOrtak.islem(formData, "ServisAksesuarGetir", "", false).then(a => {
    var sonuc = <any>a;

    this.gidenaksesuar = sonuc.SonucObject;
  })


}
PersonelleriGetir()
{
this.bllOrtak.islemWithoutPost("PersonelGetirServisKayit","",false).then(a=>{
  var sonuc=<any>a;
  this.personelListesi=sonuc.SonucObject;
})
}
kaydet() {
  var formData = new FormData();
  if (this.boslukKontrol()) {
    if (this.base64Image != null)
    formData.append("base64", this.base64Image);
  
    formData.append("Servis_json", JSON.stringify(this.isler));
    formData.append("Aksesuars", this.gidenaksesuar.join());
    this.bllOrtak.islem(formData, "ServisEkle", "", true).then(a => {
      var sonuc = <any>a;
      if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
      this.viewCtrl.dismiss();
    })
  }
}
boslukKontrol() {
  var mesaj = "";
  if (this.isler.AdSoyad == null || this.isler.AdSoyad == "") {
    mesaj = mesaj + "Lütfen Müşteri adını giriniz. <br/>";
  }
  if (mesaj == "") {
    return true;
  }
  else {
    this.ortak.showBasicAlert("Uyarı", mesaj);
    return false;
  }
}
MarkalariGetir() {
  var formData = new FormData();
  formData.append("aranan", this.aranan);
  formData.append("skip", this.skip.toString());
  formData.append("take", this.take.toString());
  this.bllOrtak.islem(formData, "MarkaListesi", "", false).then(a => {
    var sonuc = <any>a;
    this.MarkaListesi = sonuc.SonucObject;
  })
}
DurumGetir() {
  var formData = new FormData();
  formData.append("aranan", this.aranan);
  formData.append("skip", this.skip.toString());
  formData.append("take", this.take.toString());
  this.bllOrtak.islem(formData, "DurumListesi", "", false).then(a => {
    var sonuc = <any>a;
    this.DurumListesi = sonuc.SonucObject;
  })
}
AciklamaGetir() {
  var formData = new FormData();
  formData.append("aranan", this.aranan);
  formData.append("skip", this.skip.toString());
  formData.append("take", this.take.toString());
  this.bllOrtak.islem(formData, "AksesuarListesi", "", false).then(a => {
    var sonuc = <any>a;
    this.AciklamaListesi = sonuc.SonucObject;
  })
}
kapat() {
  this.viewCtrl.dismiss();
}
fileUpload(event) {
  let fd = new FormData();
  fd.append('file', event.srcElement.files[0]);
  var file = event.srcElement.files[0]
  if (file) {
    var reader = new FileReader();
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsBinaryString(file);
  }
}
_handleReaderLoaded(readerEvt) {
  var binaryString = readerEvt.target.result;
  this.base64Image = btoa(binaryString);
  this.kayitliresim = 'data:image/jpeg;base64,' + this.base64Image;
}
FotografCek() {
  this.camera.getPicture({
    destinationType: this.camera.DestinationType.DATA_URL,
    sourceType: this.camera.PictureSourceType.CAMERA,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE,
    targetWidth: 1000,
    targetHeight: 1000
  }).then((imageData) => {
    // imageData is a base64 encoded string
    this.base64Image = imageData;
    this.kayitliresim = 'data:image/jpeg;base64,' + this.base64Image;
  }, (err) => {
  });
}
GaleriyeGit() {
  this.camera.getPicture({
    destinationType: this.camera.DestinationType.DATA_URL,
    sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE,
    targetWidth: 1000,
    targetHeight: 1000
  }).then((imageData) => {
    // imageData is a base64 encoded string
    this.base64Image = imageData;
    this.kayitliresim = 'data:image/jpeg;base64,' + this.base64Image;
  }, (err) => {
    console.log(err);
  });
}



}



// WEBPACK FOOTER //
// ./src/pages/ServisKayit/servis-duzenle/servis-duzenle.ts